// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/PalaceScriptMT.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Palace Script MT';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

#contact {
  padding: 50px 0; /* Adjusted padding for better spacing */
}

.fade-in {
  opacity: 0;
  animation: fadeIn 1s forwards;
}

.fade-in-header {
  animation-delay: 0s;
}

.fade-in-contact-details {
  animation-delay: 1s;
}

.fade-in-form {
  animation-delay: 2s;
}

.fade-in-map {
  animation-delay: 3s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

#contact h1 {
  padding-top: 5%;
  font-family: 'Palace Script MT', cursive;
  font-size: 6rem; /* Adjusted font size for better readability */
  color: #000000; /* Warm brown color */
  text-align: center;
  margin-bottom: 2rem;
}

.contact-details {
  text-align: center;
  font-family: Georgia, 'Times New Roman', Times, serif;
  color: #000000; /* Warm brown color */
  margin-bottom: 2rem;
}

.contact-details p {
  margin: 0;
  font-size: 1.2rem;
}

#contact .form-label {
  color: #000000; /* Warm brown color */
  font-family: Georgia, 'Times New Roman', Times, serif;
}

#contact .btn-primary {
  background-color: #000000;
  border-color: #000000;
  font-family: Georgia, 'Times New Roman', Times, serif;
}

#contact .btn-primary:hover {
  background-color: #555;
  border-color: #555;
}

.map-responsive {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
}

.map-responsive iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {

 

  #contact {
    padding: 20px 0; /* Adjusted padding for smaller screens */
  }

  #contact h1 {
    font-size: 4rem !important; /* Adjusted font size for smaller screens */
  }

  .contact-details p {
    font-size: 1rem; /* Adjusted font size for smaller screens */
  }

  .map-responsive {
    margin-top: 5%;
    padding-top: 75%; /* 4:3 Aspect Ratio for better fit on smaller screens */
  }

  form {
    padding: 5% !important;
  }
  
  .phone-link-2 {
    color: inherit; /* Inherit color from parent */
    text-decoration: none; /* Remove underline */
  }
  
  .phone-link-2:hover,
  .phone-link-2:focus,
  .phone-link-2:active {
    color: inherit; /* Inherit color on hover/focus/active */
    text-decoration: none; /* Remove underline on hover/focus/active */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/contact-us/ContactUs.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,+DAAoE;AACtE;;AAEA;EACE,eAAe,EAAE,wCAAwC;AAC3D;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,eAAe,EAAE,8CAA8C;EAC/D,cAAc,EAAE,qBAAqB;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,cAAc,EAAE,qBAAqB;EACrC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc,EAAE,qBAAqB;EACrC,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,sBAAsB;EAC3C,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE;IACE,eAAe,EAAE,yCAAyC;EAC5D;;EAEA;IACE,0BAA0B,EAAE,2CAA2C;EACzE;;EAEA;IACE,eAAe,EAAE,2CAA2C;EAC9D;;EAEA;IACE,cAAc;IACd,gBAAgB,EAAE,uDAAuD;EAC3E;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc,EAAE,8BAA8B;IAC9C,qBAAqB,EAAE,qBAAqB;EAC9C;;EAEA;;;IAGE,cAAc,EAAE,wCAAwC;IACxD,qBAAqB,EAAE,2CAA2C;EACpE;AACF","sourcesContent":["@font-face {\n  font-family: 'Palace Script MT';\n  src: url('../../assets/fonts/PalaceScriptMT.ttf') format('truetype');\n}\n\n#contact {\n  padding: 50px 0; /* Adjusted padding for better spacing */\n}\n\n.fade-in {\n  opacity: 0;\n  animation: fadeIn 1s forwards;\n}\n\n.fade-in-header {\n  animation-delay: 0s;\n}\n\n.fade-in-contact-details {\n  animation-delay: 1s;\n}\n\n.fade-in-form {\n  animation-delay: 2s;\n}\n\n.fade-in-map {\n  animation-delay: 3s;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n#contact h1 {\n  padding-top: 5%;\n  font-family: 'Palace Script MT', cursive;\n  font-size: 6rem; /* Adjusted font size for better readability */\n  color: #000000; /* Warm brown color */\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.contact-details {\n  text-align: center;\n  font-family: Georgia, 'Times New Roman', Times, serif;\n  color: #000000; /* Warm brown color */\n  margin-bottom: 2rem;\n}\n\n.contact-details p {\n  margin: 0;\n  font-size: 1.2rem;\n}\n\n#contact .form-label {\n  color: #000000; /* Warm brown color */\n  font-family: Georgia, 'Times New Roman', Times, serif;\n}\n\n#contact .btn-primary {\n  background-color: #000000;\n  border-color: #000000;\n  font-family: Georgia, 'Times New Roman', Times, serif;\n}\n\n#contact .btn-primary:hover {\n  background-color: #555;\n  border-color: #555;\n}\n\n.map-responsive {\n  position: relative;\n  overflow: hidden;\n  padding-top: 56.25%; /* 16:9 Aspect Ratio */\n  height: 0;\n}\n\n.map-responsive iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n@media (max-width: 768px) {\n\n \n\n  #contact {\n    padding: 20px 0; /* Adjusted padding for smaller screens */\n  }\n\n  #contact h1 {\n    font-size: 4rem !important; /* Adjusted font size for smaller screens */\n  }\n\n  .contact-details p {\n    font-size: 1rem; /* Adjusted font size for smaller screens */\n  }\n\n  .map-responsive {\n    margin-top: 5%;\n    padding-top: 75%; /* 4:3 Aspect Ratio for better fit on smaller screens */\n  }\n\n  form {\n    padding: 5% !important;\n  }\n  \n  .phone-link-2 {\n    color: inherit; /* Inherit color from parent */\n    text-decoration: none; /* Remove underline */\n  }\n  \n  .phone-link-2:hover,\n  .phone-link-2:focus,\n  .phone-link-2:active {\n    color: inherit; /* Inherit color on hover/focus/active */\n    text-decoration: none; /* Remove underline on hover/focus/active */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
